import React from "react";

const Configuration = ({
    dataCenterData,
    showSensors
}) => {
    return (
        <>
        {showSensors && dataCenterData?.data?.length > 0 && (
            <div style={{ width: '100%', overflowX: 'auto' }}>
                <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    padding: '8px'
                }}>
                    <thead>
                        <th style={{
                            padding: '8px',
                            backgroundColor: '#f5f5f5',
                            borderBottom: '2px solid #ddd',
                            textAlign: 'left',
                            minWidth: "50px"
                        }}>#</th>

                        {dataCenterData?.headers?.map(ele => (
                            <th key={ele} style={{
                                padding: '8px',
                                backgroundColor: '#f5f5f5',
                                borderBottom: '2px solid #ddd',
                                textAlign: 'left',
                                minWidth: "120px"
                            }}>{ele}</th>
                        ))}
                    </thead>
                    <tbody>
                        {dataCenterData?.data?.map((ele, i) => (
                            <tr key={`device_row_${i}`} style={{
                                backgroundColor: i % 2 === 0 ? '#ffffff' : '#f9f9f9',
                                borderBottom: '1px solid #ddd'
                            }}>
                                <td style={{
                                    padding: '8px',
                                    fontWeight: '300',
                                    color: '#000',
                                    borderBottom: '1px solid #ddd'
                                }}>{i+1}</td>
                                {dataCenterData?.headers?.map((header, index) => (
                                    <td key={`device_${index}`} style={{
                                        padding: '8px',
                                        fontWeight: '300',
                                        color: '#000',
                                        borderBottom: '1px solid #ddd'
                                    }}>
                                        {ele[header.replace(/ /g, "_")] || "--"}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
        }
        </>
    )
}

export default Configuration;